module.exports = __webpack_public_path__ + "img/approval-rejected.6fc964ca.svg";